/**
 * @param {ApiManagerTimeline} timeline
 * @param {string} eventId
 * @param {{ start: string, end: string, toResourceId: string }} patch
 * @returns {ApiManagerTimeline}
 */
export const applyFastEditToTimelineData = (timeline, eventId, patch) => ({
  ...timeline,
  events: timeline.events.map((event) => {
    if (event.id !== eventId) {
      return event;
    }
    const resourceIds = patch.toResourceId
      ? [patch.toResourceId]
      : event.resourceIds;
    return {
      ...event,
      start: patch.start,
      end: patch.end,
      resourceIds,
    };
  }),
});

/**
 * @param {ApiManagerTimeline} timeline
 * @param {string} eventId
 * @returns {ApiManagerTimeline}
 */
export const removeEventFromTimelineData = (timeline, eventId) => ({
  ...timeline,
  events: timeline.events.filter((event) => event.id !== eventId),
});
